import {
    SET_APPLICANT,
    SET_APPLICANT_NAME,
    SET_APPLICANT_SURNAME,
    SET_APPLICANT_DATE_OF_BIRTH,
    SET_APPLICANT_CITY,
    SET_APPLICANT_POSTAL_CODE,
    SET_APPLICANT_STREET,
    SET_APPLICANT_HOUSE_NUMBER,
    SET_APPLICANT_PHONE,
    SET_APPLICANT_DETAILS_PENDING,
    SET_APPLICANT_DETAILS_FULFILLED,
    SET_APPLICANT_SHOW_ERROR,
} from '../../../constants/ActionTypes';
import applicantDetailsInitialState from './applicantDetailsInitialState';

function applicantDetailsReducer(state = applicantDetailsInitialState, action) {
    switch (action.type) {
    case SET_APPLICANT: {
        const { applicant } = action;
        return {
            ...state,
            applicant: {
                name: applicant.name,
                surname: applicant.surname,
                dateOfBirth: applicant.dateOfBirth,
                phone: applicant.phone,
                address: {
                    ...state.applicant.address,
                    city: applicant.address.city,
                    postalCode: applicant.address.postalCode,
                    street: applicant.address.street,
                    houseNumber: applicant.address.houseNumber,
                },
            },
        };
    }
    case SET_APPLICANT_NAME: {
        return {
            ...state,
            applicant: {
                ...state.applicant,
                name: action.event.target.value,
            },
        };
    }
    case SET_APPLICANT_SURNAME: {
        return {
            ...state,
            applicant: {
                ...state.applicant,
                surname: action.event.target.value,
            },
        };
    }
    case SET_APPLICANT_DATE_OF_BIRTH: {
        return {
            ...state,
            applicant: {
                ...state.applicant,
                dateOfBirth: action.event.target.value,
            },
        };
    }
    case SET_APPLICANT_CITY: {
        return {
            ...state,
            applicant: {
                ...state.applicant,
                address: {
                    ...state.applicant.address,
                    city: action.event.target.value,
                },
            },
        };
    }
    case SET_APPLICANT_POSTAL_CODE: {
        return {
            ...state,
            applicant: {
                ...state.applicant,
                address: {
                    ...state.applicant.address,
                    postalCode: action.event.target.value,
                },
            },
        };
    }
    case SET_APPLICANT_STREET: {
        return {
            ...state,
            applicant: {
                ...state.applicant,
                address: {
                    ...state.applicant.address,
                    street: action.event.target.value,
                },
            },
        };
    }
    case SET_APPLICANT_HOUSE_NUMBER: {
        return {
            ...state,
            applicant: {
                ...state.applicant,
                address: {
                    ...state.applicant.address,
                    houseNumber: action.event.target.value,
                },
            },
        };
    }
    case SET_APPLICANT_PHONE: {
        return {
            ...state,
            applicant: {
                ...state.applicant,
                phone: action.event.target.value,
            },
        };
    }
    case SET_APPLICANT_DETAILS_PENDING: {
        return {
            ...state,
            isPending: true,
        };
    }
    case SET_APPLICANT_DETAILS_FULFILLED: {
        return {
            ...state,
            isPending: false,
        };
    }
    case SET_APPLICANT_SHOW_ERROR: {
        return {
            ...state,
            showError: {
                ...state.showError,
                [action.fieldName]: true,
            },
        };
    }
    default:
        return state;
    }
}

export default applicantDetailsReducer;



// WEBPACK FOOTER //
// ./src/app/FormStepper/ApplicantDetails/applicantDetailsReducer.js